import { render, staticRenderFns } from "./HRMReports.vue?vue&type=template&id=f5fc3022"
import script from "./HRMReports.vue?vue&type=script&lang=js"
export * from "./HRMReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports